import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { sideBar } from '../../core/constants/sidebar.const';
import { assets } from '../../core/constants/assets.const';
import { AuthService } from '../../services/auth.service';
import { ModuleConst, userRole } from '../../core/constants/keys.constant';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { LoginResponse } from '../../models/auth.model';
import { SideBar } from '../../models/sideBar.model';
import { Router } from '@angular/router';

@Component({
  selector: 'mindbase-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnDestroy, OnInit {
  private destroy: Subject<boolean> = new Subject<boolean>();
  assetsConst = assets;
  public sideBar = sideBar;
  public innerWidth = 0;
  public sidenavWidth = 5;
  protected moduleConst = ModuleConst;
  private subscriptionSubject$: Subscription;
  protected webLogo: any;

  constructor(
    public _authService: AuthService,
    private router: Router
  ) {
    this.subscriptionSubject$ = this._authService.profileDetails
      .pipe(takeUntil(this.destroy))
      .subscribe((res: LoginResponse | null) => {
        if (res !== null) {
          this.handleSideBar(res);
        }
      });
  }
  increase(): void {
    this.sidenavWidth = 15;
  }
  decrease(): void {
    this.sidenavWidth = 4;
  }

  @HostListener('window', ['$event'])
  toggleSidenav(): void {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth <= 1199.98) {
      this._authService.toggleSidebarView();
    }
  }

  ngOnInit(): void {
    this.webLogo = JSON.parse(localStorage.getItem('webSettings') || '{}')?.adminLogo || '';
  }

  private handleSideBar(res: LoginResponse): void {
    if (res.role === userRole.SUBADMIN) {
      this.subAdminRoleHandler(res);
    } else {
      this.sideBar.forEach((el: SideBar) => {
        el.isView = el.isAdd = el.isEdit = el.isDelete = true;
        el.subMenuItems?.forEach((item: SideBar) => {
          item.isView = item.isAdd = item.isEdit = item.isDelete = true;
        });
      });
    }
  }


  private subAdminRoleHandler(res: LoginResponse): void {
    const removeableItems = new Set([this.moduleConst.ManageSubAdmin]);

    this.sideBar = this.sideBar.filter(item => {
      if (removeableItems.has(item.sideBarId)) {
        return false;
      }

      const current = res.accessRole.permissions?.find(
        perm => perm.sideBarId === item.sideBarId
      );
      if (current) {
        item.isView = current.isView;
        item.isAdd = current.isAdd;
        item.isEdit = current.isEdit;
        item.isDelete = current.isDelete;
        if (item.subMenuItems && current.subMenuItems?.length) {
          item.subMenuItems = item.subMenuItems.map(staticSub => {
            const match = current?.subMenuItems?.find(
              s => s.sideBarId === staticSub.sideBarId
            );
            if (match) {
              return {
                ...staticSub,
                isView: match.isView,
                isAdd: match.isAdd,
                isEdit: match.isEdit,
                isDelete: match.isDelete
              };
            }
            return staticSub;
          })
            .filter(sub => sub && sub.isView);
        }
      }

      return true;
    });
  }


  onItemClick(item: SideBar): void {
    this.router.navigate([item.path]);
  }
  toggleSidenavWeb(): void {
    this._authService.toggleSidebarView();
  }


  ngOnDestroy(): void {
    this.destroy.next(true);
    this.destroy.complete();
    this.subscriptionSubject$.unsubscribe();
  }
}
